<ion-content class="theme-{{userService.theme}}">
<ion-header class="transparent absolute">
    <app-header [middleIcon]="false" [hide930]="true"></app-header>
</ion-header>

<div class="blue-bg" [ngClass]="'bg-inner-'+userService.theme" *ngIf="level === 'learner'" [@enter]>
    <div class="content-wrap-inner">
        <img class="side-logo" [src]="userService.companyLogo">
        <div class="title my-color-blue">{{'__COACHING_COACHING_AREA__' | translate}}</div>

        <div class="text-large">{{'__COACHING_ON_THE_JOB_COACHING_REPORTS__' | translate}}</div>
        <div class="text">{{'__COACHING_ALL_ON_THE_JOB_COACHING_REPORTS_TEXT1__' | translate}}</div>
    </div>
</div>

<div class="blue-bg" [ngClass]="'bg-inner-'+userService.theme" *ngIf="level === 'manager'" [@enter]>
    <div class="content-wrap-inner">
        <img class="side-logo" [src]="userService.companyLogo">
        <div class="title my-color-blue">{{'__COACHING_COACHING_AREA__' | translate}}</div>

        <div class="text-large">{{'__COACHING_ON_THE_JOB_COACHING_REPORTS__' | translate}}</div>

        <div class="combo">
            <div class="my-color-blue">{{"__COACHING_NAME__" | translate }}</div>
            <div class="date" *ngIf="pageData !== null" [@enter]>{{pageData.delegate.full_name}}</div>
        </div>
    </div>
</div>

<div class="plus-box" (click)="onPlusClick()" *ngIf="userService.userInfo.company.enabled_cr_self"><app-inline-svg [file]="'assets/icon/plus-yellow.svg'"></app-inline-svg></div>

<div class="del-wrap content-wrap" *ngIf="!!pageData">
    <div class="group" *ngFor="let item of pageData?.reports.details; let i = index"
         [@leave]>
        <div (click)="goReport(item.id);" class="white-box">
            <div *ngIf="item.type === 'SELF'" class="date">
                <span style="font-size: 1.6rem; ">{{item.coachee_name}}</span><br>{{item.date.output.long}}
            </div>
            <div *ngIf="item.type === 'OTHERS'" class="date">{{item.date.output.long}}</div>
            <div class="number {{item.average.average.output.style.class}}">{{item.average.average.output.value}}</div>
        </div>
        <ng-container *ngIf="item.type === 'OTHERS'">
            <app-dropdown *ngIf="item.comment !== ''" title="{{'__COACHING_MANAGER_COMMENTS__'  | translate}}" [text]="item.comment"></app-dropdown>
            <app-dropdown *ngIf="item.comment === ''" title="{{'__COACHING_MANAGER_COMMENTS__'  | translate}}" text="{{'__COACHING_NO_COMMENT__' | translate}}"></app-dropdown>
        </ng-container>
        <ng-container *ngIf="item.type === 'SELF'">
            <app-dropdown style="margin-bottom: 0.4rem" *ngIf="item.comment_self_1 !== ''" title="{{'__COACHING_SELF_COMMENT_ONE__' | translate}}" [text]="item.comment_self_1"></app-dropdown>
            <app-dropdown style="margin-bottom: 0.4rem" *ngIf="item.comment_self_1 === ''" title="{{'__COACHING_SELF_COMMENT_ONE__' | translate}}" text="{{'__COACHING_NO_COMMENT__' | translate}}"></app-dropdown>
            <app-dropdown style="margin-bottom: 0.4rem" *ngIf="item.comment_self_2 !== ''" title="{{'__COACHING_SELF_COMMENT_TWO__' | translate}}" [text]="item.comment_self_2"></app-dropdown>
            <app-dropdown style="margin-bottom: 0.4rem" *ngIf="item.comment_self_2 === ''" title="{{'__COACHING_SELF_COMMENT_TWO__' | translate}}" text="{{'__COACHING_NO_COMMENT__' | translate}}"></app-dropdown>
            <app-dropdown *ngIf="item.comment_self_3 !== ''" title="{{'__COACHING_SELF_COMMENT_THREE__' | translate}}" [text]="item.comment_self_3"></app-dropdown>
            <app-dropdown *ngIf="item.comment_self_3 === ''" title="{{'__COACHING_SELF_COMMENT_THREE__' | translate}}" text="{{'__COACHING_NO_COMMENT__' | translate}}"></app-dropdown>
        </ng-container>
    </div>
</div>

<div class="del-wrap content-wrap" *ngIf="pageData === null">
    <app-skeleton-list></app-skeleton-list>
</div>
</ion-content>
